var exports = {
  "k": "xcc377c0b--becc1c--container",
  "p": "xcc377c0b--becc1c--list",
};

module.exports = exports;
